// Fachada de administração global (SuperAdmin) — métodos do repo (ver core.ts).
import { superAdminRepo } from './core';

// Tipos do domínio (linhas de tabela + view-models de SELECTs com join).
export type {
  ISuperAdminRepository,
  AdminCreateUserParams,
  CreateWorkspaceParams,
  AdminActivityFeedItem,
  ProfileRow,
  WorkspaceRow,
  WorkspaceMemberRow,
  TimeRow,
  TimeMemberRow,
  FunnelRow,
  PipelineStageRow,
  AdminActivityLogRow,
  WorkspaceMemberWithWorkspace,
  WorkspaceMemberWithProfile,
  WorkspaceMemberWithProfileByWorkspace,
  TimeMemberWithTime,
  TimeMemberWithProfile,
  AdminActivityLogWithActor,
} from '@modules/superAdmin';

export const listAllProfiles                   = superAdminRepo.listAllProfiles;
export const updateProfileRole                 = superAdminRepo.updateProfileRole;
export const setProfileActive                  = superAdminRepo.setProfileActive;
export const adminCreateUser                   = superAdminRepo.adminCreateUser;
export const getAuthUserEmail                  = superAdminRepo.getAuthUserEmail;
export const updateUserEmail                   = superAdminRepo.updateUserEmail;
export const setUserPassword                   = superAdminRepo.setUserPassword;
export const signInAsUser                      = superAdminRepo.signInAsUser;
export const listWorkspacesAdmin               = superAdminRepo.listWorkspacesAdmin;
export const listActiveWorkspaces              = superAdminRepo.listActiveWorkspaces;
export const createWorkspace                   = superAdminRepo.createWorkspace;
export const setWorkspaceActive                = superAdminRepo.setWorkspaceActive;
export const setWorkspaceSettingsFlag          = superAdminRepo.setWorkspaceSettingsFlag;
export const listWorkspaceMembersWithWorkspace = superAdminRepo.listWorkspaceMembersWithWorkspace;
export const listWorkspaceMembersWithProfile   = superAdminRepo.listWorkspaceMembersWithProfile;
export const listWorkspaceMembersByWorkspace   = superAdminRepo.listWorkspaceMembersByWorkspace;
export const upsertWorkspaceMember             = superAdminRepo.upsertWorkspaceMember;
export const setWorkspaceMemberActive          = superAdminRepo.setWorkspaceMemberActive;
export const deleteWorkspaceMember             = superAdminRepo.deleteWorkspaceMember;
export const updateWorkspaceMemberRole         = superAdminRepo.updateWorkspaceMemberRole;
export const setWorkspaceMemberComercial       = superAdminRepo.setWorkspaceMemberComercial;
export const listTimeMembersWithTime           = superAdminRepo.listTimeMembersWithTime;
export const listTimes                         = superAdminRepo.listTimes;
export const listTimeMembersByTimeIds          = superAdminRepo.listTimeMembersByTimeIds;
export const createTime                        = superAdminRepo.createTime;
export const upsertTimeMember                  = superAdminRepo.upsertTimeMember;
export const setTimeMemberActive               = superAdminRepo.setTimeMemberActive;
export const updateTimeMemberRole              = superAdminRepo.updateTimeMemberRole;
export const updateTimeName                    = superAdminRepo.updateTimeName;
export const listFunnelsByWorkspace            = superAdminRepo.listFunnelsByWorkspace;
export const listStagesByPipelineIds           = superAdminRepo.listStagesByPipelineIds;
export const toggleFunnelActive                = superAdminRepo.toggleFunnelActive;
export const updateStageName                   = superAdminRepo.updateStageName;
export const listActivityLog                   = superAdminRepo.listActivityLog;
export const listActivityFeed                  = superAdminRepo.listActivityFeed;
export const logActivity                       = superAdminRepo.logActivity;
